import Link from "next/link";

export default function LandingSEO() {
  return (
    <div>
      <p>
        <strong>About BetQL</strong>
      </p>
      <p>
        BetQL is a sports-betting analytics platform designed to help bettors identify value, track trends, and make
        informed wagers across all major sports. We use our state-of-the-art computer model to analyze every bet, every
        day to find mis-priced lines. By combining robust data modeling, real-time odds monitoring, expert insight, and
        quantitative trends, we aim to elevate both casual and serious bettors from guesswork to strategy.
      </p>
      <p>
        <strong>Types of Betting Predictions</strong>
      </p>
      <p>
        We offer a variety of betting predictions including moneyline, spread and over/under picks for all major sports.
        All BetQL computer model predictions created using a proprietary algorithm designed to identify trends and
        patterns that can help you make informed betting decisions. Each game or match is simulated 10,000 times based
        on all available data providing BetQL subscribers with a fact based prediction and clear probability
        projections.
      </p>
      <p>
        <strong>Computer Analyzed Prediction Program</strong>
      </p>
      <p>
        Every bet on BetQL receives a{" "}
        <a href="https://support.betql.co/hc/en-us/articles/360047973014-BetQL-Model-Bets-Understanding-Star-Ratings">
          star rating
        </a>{" "}
        based on historical data, matchup details, homefield advantage, weather, injuries, and narratives. Bets are
        rated on a scale of 1-5 stars indicating their advantage for the bettor. The higher the number of stars the
        bigger the edge. As external factors (e.g., a new injury or favorable weather shift) alter betting lines, BetQL
        updates our star ratings throughout the day to reflect real-time opportunities.
      </p>
      <p>
        <strong>Exclusive Public Betting Data</strong>
      </p>
      <p>
        In addition to the standard computer based moneyline, spread and over/under predictions, BetQl also provides its
        users with public and expert betting data. This allows bettors to gauge public sentiment towards a specific
        wager as well as see where the sharps (experts) think the odds makers may have made a mistake and are taking the
        underdog. Our “trending bets” section gives bettors an overview of our computer model, sharp betting and the
        BetQL community's prediction all in one place.
      </p>
      <p>
        <strong>Specialized Sports Predictions</strong>
      </p>
      <p>
        Each sport has its own dedicated section on the BetQL site where bettors can find predictions for sports
        specific wages such as <Link href="/mlb/odds/first-five-innings-odds">MLB first five innings</Link>,{" "}
        <Link href="/nba/odds/first-half-lines">NBA first half</Link> or{" "}
        <Link href="/nfl/prop-picks">NFL player prop bets</Link>. Regardless of your sport of choice BetQL has the
        information you need to make an informed pick with the sportsbook of your choice.
      </p>
      <p>
        <strong>Intuitive Prediction Tools</strong>
      </p>
      <p>
        <Link href="/">BetQL.co</Link> features tailored tools for both novice and sharp bettors including our line
        movement tracker and full game/match analysis. Our line movement tracking feature allows you to see how the
        betting odds have changed since their announcement and are updated every 5 minutes to give you the latest odds.
        The game/match analysis gives complete breakdowns of the matchup including historic trends, projected winning
        percentages as well as the latest lines from top sportsbooks.
      </p>
      <p>
        <strong>Daily News from BetQL Sports Experts</strong>
      </p>
      <p>
        We've compiled a team of sports betting experts who create daily news articles where they share their top picks.
        Additionally, we have daily computer picks articles, where the highest rated predictions for every league are
        highlighted. We don't stop at just the moneyline, our experts break down the latest player props as well as game
        prop bets like{" "}
        <Link href="/mlb/news/best-nrfi-bets-today-no-runs-first-inning-odds">MLB No Runs in the 1st Inning</Link>.
      </p>
      <p>
        <strong>Top Promo Offers</strong>
      </p>
      <p>
        BetQL is also your home for top <Link href="/sportsbook-offers">sportsbook</Link>,{" "}
        <Link href="/casino-offers">casino</Link> and <Link href="/boosts">odds boost</Link> promotional offers. We've
        partnered with the top online sportsbooks and casinos in the US to provide BetQL users with exclusive offers
        designed to help you maximize your bets. We're constantly adding new offers so check back regularly for the best
        promo offers in the betting industry.
      </p>
      <p>
        <strong>Subscriptions to fit your needs</strong>
      </p>
      <p>
        From a first time bettor, looking to test the waters, to a sharp searching for a mispriced line that could make
        all the difference, the <Link href="/pricing/monthly">BetQL subscription</Link> model has something to offer for
        everyone. Whether you're only interested in picks for 1 or 2 sports or want access to predictions for every
        league all year round, BetQL has a package for you, all available with no long-term commitment.
      </p>
    </div>
  );
}
